import { TemplateCategoryFiltersTable } from '@/types/template.types';
import { Post } from '../helpers';

const CreateNewTemplateCategory = ({
  channel,
  title,
}: {
  channel: number;
  title: string;
}): Promise<TemplateCategoryFiltersTable> => {
  return Post({
    path: `/v3/admin/templates-category-filters/categories/events/${channel}`,
    body: { title },
  });
};

export default CreateNewTemplateCategory;
